export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-4.4c8c8c2e.png";